import { on, select, getData } from 'modules/dom'
import { pipe, then, map, fetchData } from 'modules/utils'
import TinyDatePicker from 'tiny-date-picker'
import Carousel from 'modules/carousel'

export default function (el) {
  const t = this
  /**
   * Define objects
   */
  t.inputPicker = select('.js-date-value', el)
  t.getEndPoint = getData('load-uri', el)
  t.carouselEl = select('.js-date-carousel', el)
  t.carouselItem = select('.js-date-carousel__item', t.carouselEl)
  t.carouselMonth = select('.js-load-month', t.carouselItem)
  t.carouselDay = select('.js-load-day', t.carouselItem)
  t.carouselYear = select('.js-load-year', t.carouselItem)
  t.carouselDescription = select('.js-load-description', t.carouselItem)
  t.dateCarousel = new Carousel(t.carouselEl)

  const settings = {
    mode: 'dp-below',
    days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    parse (str) {
      let date = new Date(str)
      const result = isNaN(date) ? new Date() : date
      const stringDate = result.getFullYear() + '/' + (result.getMonth() + 1) + '/' + result.getDate()
      return new Date(stringDate)
    }
  }
  t.datePicker = TinyDatePicker(t.inputPicker, settings)

  const destroyCarousel = () => {
    t.dateCarousel.destroy()
  }

  const appendCarouselContent = (htmlString) => {
    t.carouselEl.innerHTML = htmlString
  }

  const carouselInit = () => {
    t.dateCarousel = new Carousel(t.carouselEl)
  }

  const updateCarousel = (list) => {
    destroyCarousel()
    let htmlStringCarousel = ''
    map(item => {
      if (item.month && item.day && item.year && item.post_excerpt) {
        t.carouselMonth.textContent = item.month
        t.carouselDay.textContent = item.day
        t.carouselYear.textContent = item.year
        t.carouselDescription.textContent = item.post_excerpt
        htmlStringCarousel += t.carouselItem.outerHTML
      }
    }, list)
    appendCarouselContent(htmlStringCarousel)
    carouselInit()
  }

  const updateDate = (response, currentValue) => {
    // Prevent IE bug
    if (typeof response === 'string') {
      response = JSON.parse(response)
    }
    updateCarousel(response)
  }

  on('change', () => {
    t.datePicker.close()
    const date = new Date(t.inputPicker.value)
    const endpoint = t.getEndPoint + (date.getMonth() + 1) + '/' + date.getDate()
    pipe(
      fetchData,
      then((response) => {
        updateDate(response, parseInt(t.inputPicker.value))
      })
    )(endpoint)
  }, t.inputPicker)
}
